/* eslint-disable */
/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import Icon from '@mdi/react';
import { TabPane, Tab } from 'semantic-ui-react'
import { mdiChevronDown, mdiChevronUp, mdiCheck,mdiAlert } from '@mdi/js';
import GBButton from '../../components/GBButton/GBButton';
import GBConfirm from '../../components/GBConfirm/GBConfirm';
import {getZoneMetrics} from '../../api/zone';
import { getBlockMetrics } from '../../api/zone';
import { confirmAlert } from 'react-confirm-alert';
import {plans} from './plans';
import Panel1 from './Panel1';
import Panel2 from './Panel2';

const PlanInformation = ({ zoneInfo, updateZonePlan, toggleShowInfo, billingDate }) => {

  /* 1-15-2021 We need to verify the plan they are selecting is allowed based on their current
  plan and whether the new plan would exceed any new plan metrics.  Items to check
  1. Storage space of new plan versus current usage.
  2. Number of new plan blocks versus current blocks total
  3. Number of new plan rows per block versus current rows per block.
  4. Number of new allowed phone numbers versus current numbers in use.

  */
    const checkPlanRequirements = async (newplan) => {
      
      // current metrics.
      let isValidPlan = true;
      const selectedPlan = plans.filter(itm=>itm.type===newplan)[0];

      const data= await getZoneMetrics(zoneInfo.zoneid,zoneInfo.plan)
      const blockdata = await getBlockMetrics();

      // Check that max records in a block don't exceed new plan limits.
      blockdata.forEach(el => {
        if(el.rows > selectedPlan.records){
          isValidPlan=false;
        }
      })

      // check they don't have more blocks than is allowed in new plan.
      if(parseInt(data.blockCount) > selectedPlan.blocks && selectedPlan.blocks !==-1)
      {
        isValidPlan=false;
      }

      // Check that the amoutn of data used so far does not exceed new plan limits.
      if(data.dataSize > selectedPlan.data) {
        isValidPlan=false;
      }

      // Check that they aren't useing more Twilio phone numbers than is allowed by new plan.
      if(zoneInfo.attributes.PhoneNumbers && zoneInfo.attributes.PhoneNumbers.length > selectedPlan.phonenumbers) {
        isValidPlan=false;
      }


      if(!isValidPlan) {
       PlanMismatch()
      } else {
        updateZonePlan(newplan)
      }
    }
    const PlanMismatch = (newplan) => {

      const message=<div>This Zone exceeds the feature/limits set by the {newplan} plan. <p></p>
      <p>To downgrade to this plan you must first ensure the Zone is under the limits specified
        for the plan you wish to change to.</p><p/>
      <p>Instead, if you wish to stop payment by deactivating the Zone, this can be done by
        navigating to the My Profile page. In the Zone information section, choose Deactivate for the
      desired Zone in the list.</p></div>

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <GBConfirm
              title="Plan selection mismatch"
              action={onClose}
              showCancelButton={false}
              buttonLabel="OK"
              message={message}
              showInput={false}
              height="350px"
              width-="400px"
            />
          );
        },
      });
  }


  const panes = [
    {
      menuItem: 'Essential Plans',
      render: () => <TabPane attached={false}><Panel2 billingDate={billingDate} zoneInfo={zoneInfo} checkPlanRequirements={checkPlanRequirements}/></TabPane>,
    },
    {
      menuItem: 'Advanced Plans',
      render: () => <TabPane attached={false}><Panel1 billingDate={billingDate} zoneInfo={zoneInfo} checkPlanRequirements={checkPlanRequirements}/></TabPane>,
    },
  ]

  const lightBorderColor = '#d4d4d5';

  return (
    <div css={{ 
      overflow: 'auto', 
      marginTop:'10px',
      height: 'calc(100vh - 180px)',
      '& .ui.active.tab.segment': {
        border: 'none !important',
        boxShadow: 'none !important'
      },
      '& .ui.menu .active.item' :{
        backgroundColor:'#AE007B !important',
        color:'white'
      },
      '& .ui.menu' :{
        paddingLeft:'10px',
        borderBottom:'2px solid #AE007B !important',
        borderRadius:'0px !important',
        borderTop:'none !important',
       '& .active.item' : {
        borderTopLeftRadius: '10px !important',
        borderTopRightRadius: '10px !important',
       },
       '& .item:not(.active)': {
        backgroundColor:'#f9f9f9 !important',
        borderTop: '1px solid #d4d4d5 !important',
        borderBottom: 'none !important',
        borderLeft:'1px solid #d4d4d5 !important',
        borderRight:'1px solid #d4d4d5 !important',
        borderTopLeftRadius: '10px !important',
        borderTopRightRadius: '10px !important',
       }
      }
    }}>
  
     <Tab menu={{ attached: false, tabular: false,borderless:true }} panes={panes} />
    </div>
  );
};

export default PlanInformation;
